import { React, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';
import { clicks, useHandleAddToCart } from '../com.zedock.common.script/common.js';

import '../com.zedock.common.style/Checkout.css';
import '../com.zedock.common.style/common.css';

function Checkout() {
  const navigate = useNavigate();
  const location = useLocation();

  const userName = localStorage.getItem("userName");
  const [formData, setFormData] = useState({
    name: "",
    email: userName,
    mobile: "",
    flat: "",
    building: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    paymentMode: "razorpay",
  });
  const [loading, setLoading] = useState(false);
  const totalPrice = location.state?.totalPrice;
  const codFee = formData.paymentMode === 'COD' ? 50 : 0;
  const deliveryFee = totalPrice < 500 ? 50 : 0;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    clicks(location.pathname);
    window.scrollTo({ top: 0, behavior: 'instant' });

    getCheckout();
  }, []);

  async function getCheckout() {
    try {
      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/checkout", {
          headers: {
            "X-XSRF-TOKEN": getCsrfToken()
          },
          method: "GET",
          credentials: "include"
        })
      if (response.status === 401) {
        navigate("/Login", { state: { from: location, totalPrice: totalPrice } });
        localStorage.clear();

        return null;
      }
    }
    catch (error) {
    }
    finally {
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await fetch(`${urls.BASE_URL}` + "/zedock-web/checkout", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": getCsrfToken()
        },

        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const data = await response.json();
        //console.log("Checkout saved:", data);
        window.gtag('event', 'conversion', { 'send_to': 'AW-18382744871/2tIvCPjY7focEKfayb1E' });

        if (data.paymentMode == "razorpay") {

          const options = {
            key: "rzp_live_TUievJxmDYA7JN",   // test key_id
            order_id: data.building,     // from backend
            amount: 1,
            currency: "INR",
            name: "Zedock Solutions",
            description: "Zedock Solutions Transaction",
            handler: function (response) {
              fetch(`${urls.BASE_URL}` + "/zedock-web/checkout/verify-payment", {
                method: "POST",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                  "X-XSRF-TOKEN": getCsrfToken()
                },
                body: JSON.stringify(response)
              });
              navigate("/Order")

            }
          };
          const rzp = new window.Razorpay(options);
          rzp.open();

        }
        if (data.paymentMode == "COD") {
          navigate("/Order")
        }
      }
      else {
        navigate("/Order")
      }
    } catch (error) {
      console.error("Error:", error);
      navigate("/Product")

    }
    finally {
      setLoading(false);
    }
  };


  return (
    <div className="container px-0    ">

      <div className="zd-wrap p-2 p-lg-4">

        <div className="row g-0">
          <nav aria-label="breadcrumb" className="zd-crumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="" onClick={(e) => { e.preventDefault(); navigate("/Product") }}>Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">Checkout</li>
            </ol>
          </nav>
        </div>

        <div className="zd-checkout-head">
          <span className="zd-checkout-eyebrow">One last step</span>
          <h2>Checkout</h2>

          <div className="zd-steps">
            <span className="zd-step done zd-step-num">✓</span> Cart
            <span className="zd-step-line"></span>
            <span className="zd-step current zd-step-num">2</span> Shipping
            <span className="zd-step-line"></span>
            <span className="zd-step zd-step-num">3</span> Confirmation
          </div>
        </div>

        {loading ? (
          <div className="zd-loader-wrap text-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <form className="row   g-2 mb-2 zd-checkout-form" onSubmit={handleSubmit}>
            <div className="zd-secure-badge">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 2L4 5v6c0 5.25 3.4 10.15 8 11.5 4.6-1.35 8-6.25 8-11.5V5l-8-3z"
                  fill="currentColor"
                  opacity="0.15"
                />
                <path
                  d="M12 2L4 5v6c0 5.25 3.4 10.15 8 11.5 4.6-1.35 8-6.25 8-11.5V5l-8-3z"
                  stroke="currentColor"
                  strokeWidth="1.6"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9 12l2 2 4-4"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span>Payments secured by <strong>Razorpay</strong></span>


            </div>

            <div className='col-12 col-lg-6'>
              <div className="col-12">
                <p className="zd-fieldset-label"><span className="zd-fs-num">1</span> Contact details</p>
              </div>

              <div className="col-12  zd-field">
                <label>Full Name</label>
                <input type="text" className="form-control" name="name" value={formData.name} minLength={2} maxLength={100} onChange={handleChange} required />
              </div>
              <div className='row'>

                <div className="col-6   zd-field">
                  <label>Email</label>
                  <input type="email" className="form-control" name="email" value={userName} readOnly />
                </div>
                <div className="col-6   zd-field">
                  <label>Mobile Number</label>
                  <input type="text" className="form-control" name="mobile" value={formData.mobile} pattern="[0-9]{10}" maxLength={10} onChange={handleChange} required />
                </div>

              </div>
              <div className="col-12">
                <p className="zd-fieldset-label"><span className="zd-fs-num">2</span> Shipping address</p>
              </div>

              <div className="col-12   zd-field">
                <label>Flat / House No.</label>
                <input type="text" className="form-control" name="flat" value={formData.flat} minLength={2} maxLength={100} onChange={handleChange} required />
              </div>
              <div className="col-12   zd-field">
                <label>Building / Street</label>
                <input type="text" className="form-control" name="building" value={formData.building} minLength={2} maxLength={100} onChange={handleChange} required />
              </div>
              <div className='row'>
                <div className="col-6   zd-field">
                  <label>Landmark</label>
                  <input type="text" className="form-control" name="landmark" value={formData.landmark} minLength={2} maxLength={100} onChange={handleChange} />
                </div>
                <div className="col-6   zd-field">
                  <label>City</label>
                  <input type="text" className="form-control" name="city" value={formData.city} minLength={2} maxLength={100} onChange={handleChange} required />
                </div>
              </div>
              <div className='row'>
                <div className="col-6   zd-field">
                  <label>State</label>
                  <input type="text" className="form-control" name="state" value={formData.state} minLength={2} maxLength={100} onChange={handleChange} required />
                </div>
                <div className="col-6   zd-field">
                  <label>Pincode</label>
                  <input type="text" className="form-control" name="pincode" value={formData.pincode} pattern="[0-9]{6}" maxLength={6} onChange={handleChange} required />
                </div>
              </div>



            </div>
            <div className='col-12 col-lg-6'>

              <div className="col-12">
                <p className="zd-fieldset-label"><span className="zd-fs-num">3</span> Payment mode</p>
                <div className="zd-payment-option">
                  <div className="zd-payment-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="6" width="20" height="14" rx="2"></rect>
                      <path d="M2 10h20"></path>
                      <path d="M6 15h4"></path>
                    </svg>
                  </div>
                  <div className="zd-payment-text">
                    <strong>Payment Mode</strong>
                  </div>
                  <select className="form-select" name="paymentMode" value={formData.paymentMode} onChange={handleChange}>
                    <option value="razorpay">RazorPay</option>
                    <option value="COD">Cash on Delivery (COD)</option>

                  </select>
                </div>
              </div>


              {  /* <div class="coupon-box">
                <input type="text" placeholder="Coupon code" />
                <button>Apply</button>
              </div>
              <p class="coupon-text">Use code ZEDOCK10 to get 10% off <br />(minimum Cart value 499/-)</p>
              */
              }
              <div className="zd-sum">
                <p>Item price:</p>
                <strong>₹{totalPrice}/-</strong>


                {totalPrice < 500 && (
                  <div>
                    <p>Delivery Charges:
                      <div className='zd-info'>(Applicable on order below 499/-)</div>
                    </p>

                    <strong>₹50/-</strong>

                  </div>
                )}

                {formData.paymentMode === 'COD' && (
                  <div>
                    <p>COD Charges:</p>
                    <strong>₹50/-</strong>
                  </div>
                )}
                <p>Total Charges:</p>
                <strong>₹{totalPrice + deliveryFee + codFee}/-</strong>
              </div> 

              <div className="col-12 text-center mt-4">

                <button type="submit" className="zd-place-order">Place order</button>
              </div> 
             <div className="col-12"><hr className="zd-section-divider" /></div>

              <div className="col-12">
                <div className="zd-disclaimer">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                  </svg>
                  <p><strong>Disclaimer:</strong> Once your order is placed, items will require <strong>5–7 business days</strong> for delivery. Please ensure your address details are correct to avoid delays.</p>
                </div>
              </div>
            </div>
 
          </form>
        )}


      </div>


    </div>
  );
}

export default Checkout;
